import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'shared/api/rtk-query';

export const wccApi = createApi({
  reducerPath: 'wcc-api',
  baseQuery: createBaseQuery(),
  endpoints: () => ({}),
});
